/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Stateofcontactrequestmoredetail5Inputs */

const de__field_stateofcontactrequestmoredetail5 = /** @type {(inputs: _Field_Stateofcontactrequestmoredetail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund für Absage der Akquise-Details`)
};

/**

* @param {_Field_Stateofcontactrequestmoredetail5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_stateofcontactrequestmoredetail5 = /** @type {((inputs?: _Field_Stateofcontactrequestmoredetail5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Stateofcontactrequestmoredetail5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_stateofcontactrequestmoredetail5(inputs)
});
export { _field_stateofcontactrequestmoredetail5 as "_field_stateOfContactRequestMoreDetail" }